import { TOOLTIP_CONTENT_SELECTOR, TOOLTIP_HIDE_TIMEOUT, TOOLTIP_CONTENT_ACTIVE_CLASS } from './tooltip_handler_constants';
import { v4 as uuidv4 } from 'uuid';
import { Any } from 'ts-toolbelt';

export class TooltipHandler {
    public $tooltipTrigger: HTMLElement;
    public $tooltipContent: HTMLElement;
    private hideTimeout: number | null = null;

    constructor({ $triggerElement }: { $triggerElement: HTMLElement }) {
        this.$tooltipTrigger = $triggerElement;
        this.$tooltipContent = $triggerElement.nextElementSibling as HTMLElement;

        if (!this.$tooltipContent || !this.$tooltipContent.matches(TOOLTIP_CONTENT_SELECTOR)) return;
        
        this._setAccessibilityAttributes();
        this._bindEvents();
    }

    private _setAccessibilityAttributes() {
        const tooltipContentId = this.$tooltipContent.id || `tooltip-${uuidv4()}`;

        if (!this.$tooltipContent.id) {
            this.$tooltipContent.id = tooltipContentId;
        }
        this.$tooltipTrigger.setAttribute('aria-describedby', tooltipContentId);
        this.$tooltipContent.setAttribute('role', 'tooltip');
    }

    private _isActive(): boolean {
        return (
            this.$tooltipTrigger === document.activeElement ||
            this.$tooltipContent === document.activeElement ||
            this.$tooltipTrigger.matches(':hover') ||
            this.$tooltipContent.matches(':hover')
        );
    }

    private _updateTooltipVisibility() {
        if (this._isActive()) {
            if (this.hideTimeout) clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
            this.$tooltipContent.classList.add(TOOLTIP_CONTENT_ACTIVE_CLASS);
        } else {
            this.hideTimeout = window.setTimeout(() => {
                this.$tooltipContent.classList.remove(TOOLTIP_CONTENT_ACTIVE_CLASS);
            }, TOOLTIP_HIDE_TIMEOUT);
        }
    }

    private _bindEvents() {
        const interactionEvents: Any.Keys<DocumentEventMap>[] = ['focusin', 'mouseenter', 'focusout', 'mouseleave'];

        [this.$tooltipTrigger, this.$tooltipContent].forEach($element => {
            interactionEvents.forEach(event => {
                $element.addEventListener(event, () => this._updateTooltipVisibility());
            });
        });

        document.addEventListener("keydown", (ev: KeyboardEvent) => {
            if (!this._isActive()) return;

            if (ev.key === "Escape" && this.$tooltipContent.classList.contains(TOOLTIP_CONTENT_ACTIVE_CLASS)) {
                ev.stopPropagation();
                if (this.hideTimeout) clearTimeout(this.hideTimeout);
                this.hideTimeout = null;
                this.$tooltipContent.classList.remove(TOOLTIP_CONTENT_ACTIVE_CLASS);
            }
        });
    }
}